export namespace CustomFieldsConstants {
  export enum InputTypes {
    TITLE = 'TITLE',
    TEXT = "TEXT",
    TEXTAREA = "TEXTAREA",
    WYSIWYG = "WYSIWYG",
    NUMERIC = "NUMERIC",
    DATE = "DATE",
    DATETIME = "DATETIME",
    CHECKBOX = "CHECKBOX",
    DROPDOWN = "DROPDOWN",
    IMG = "IMG",
    FILE = "FILE",
    IBAN = "IBAN",
    PHONE = "PHONE",
    DNI = "DNI",
    DNI_NIE_PASSPORT = "DNI_NIE_PASSPORT",
    NIA = "NIA",
    EMAIL = 'EMAIL',
    MULTISELECT = "MULTISELECT",
  };

  export enum DropdownTypes {
    CHIPS = "CHIPS",
    TABLE = "TABLE"
  };

  export enum Permissions {
    READ_WRITE = 'rw'
  }
}
